<template>
  <div class="mains">
    <div class="header" id="main_header">
      <div class="centerbtn" :style="$store.state.leftMenuStatus ? '' : 'left: 0'">
        <div class="logo">
          <img src="./../../assets/images/huayi_logo.png" alt="">
        </div>
        <span>{{ $t("page.componentsTitle")}}</span>
      </div>
      <search></search>
      <div class="rightBtns">
        <!-- <span class="reset-view" title="" @click="toggleMeter()">
          <p class="toggle-meter">{{!meterShow ? '开启仪表': '关闭仪表'}}</p>
        </span> -->
        <span class="reset-view" :title="$t('home.viewsel')" @click="viewSel">
          <i class="iconfont iconicon_nav_perspective_selection"></i>
        </span>
        <span class="reset-view" :title="$t('menu.resetView')" @click="resetModel">
          <i class="iconfont iconicon_nav_camera_reset"></i>
        </span>
        <span class="collect" style="cursor:pointer;">
          <i class="iconfont iconicon_nav_favorites" style="width:20px;height:30px;margin-right:20px;" @click="()=>collectFN()"></i>
        </span>
        <span class="email">
          <el-popover popper-class="message-box" trigger="click" placement="bottom-start">
            <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
              <el-tab-pane :label="$t('menu.warn')" name="first">
                <ul class="alert-list" v-if="alertInfo.length > 0">
                  <li v-for="(i, index) in alertInfo" :key="index" @click="setGuid(i)">
                    <div class="info-top">
                      <div class="info-name">
                        <i class="el-icon-stopwatch"></i>
                        <span>{{i.concernsId}}</span>
                      </div>
                      <div class="info-time">
                        <span>{{i.createTime | dateFormat('yyyy-M-d hh:mm')}}</span>
                      </div>
                    </div>
                    <div class="info-bottom">
                      <span>{{i.messageText}}</span>
                      <i :class="i.isRead === 2? 'b': ''"></i>
                    </div>
                  </li>
                </ul>
                <div v-else class="no-data">
                  <span>没有新警报</span>
                </div>
                <el-pagination layout="prev, pager, next" :hide-on-single-page="true" :total="count" :page-size="linit" @size-change="handleSizeChange" @current-change="handleCurrentChange">
                </el-pagination>
              </el-tab-pane>
              <el-tab-pane :label="$t('menu.notify')" name="second">
                <ul class="alert-list" v-if="msgInfo.length > 0">
                  <li v-for="(i, index) in msgInfo" :key="index" @click="viewNotice(i)">
                    <div class="info-top">
                      <div class="info-name">
                        <span>{{i.title}}</span>
                      </div>
                      <div class="info-time">
                        <span>{{i.createTime | dateFormat('yyyy-M-d hh:mm')}}</span>
                      </div>
                    </div>
                    <div class="info-bottom">
                      <span v-html="i.des"></span>
                      <i :class="i.isRead === 2? 'b': ''"></i>
                    </div>
                  </li>
                </ul>
                <div v-else class="no-data">
                  <span>没有新通知</span>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div v-if="activeName === 'second'" class="box-bottom1">
              <span @click="viewNotice()">{{$t('menu.ckqb')}}</span>
            </div>
            <div v-if="activeName === 'first' && alertInfo.length > 0" class="box-bottom">
              <span @click="readAll()">{{$t('menu.qbbjyd')}}</span>
              <span @click="viewWarn()">{{$t('menu.ckqb')}}</span>
            </div>
            <el-badge :is-dot="newMsg" class="item" slot="reference">
              <i style="font-size:18px" class="iconfont iconicon-anv-message"></i>
            </el-badge>
          </el-popover>
        </span>
        <userdiv></userdiv>
        <div class="date">
          <label class="day">{{day}}</label>
          <label class="time">{{time}}</label>
        </div>

        <span class="btn-fullscreen" @click="handleFullScreen">
          <el-tooltip effect="dark" :content="fullscreen ? $t('menu.unscreen'):$t('menu.screen')" placement="bottom">
            <i class="iconfont iconicon_nav_full_screen"></i>
          </el-tooltip>
        </span>
      </div>
    </div>
    <dragg-menu @click-msg="openDialog" :showToggle="show2" @showView="showViewClick" @showEQModel="showEQModel"></dragg-menu>
    <context-menu v-show="contextMenuShow" :style="cssStr" @contextMenuClick="contextMenuClick"></context-menu>
    <custom-dialog v-if='ifDialog' @handleClose="handleDiaClose" :propsData="propsDiaData"></custom-dialog>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
import { mapState } from 'vuex'
export default {
  name: 'mainss',
  data() {
    return {
      propsDiaData: {},
      currentMenuIndex: -1,
      markerArr: [],
      markerShowField: [this.$t('menu.wh'), this.$t('menu.ms')],
      markerMenu: [
        {
          label: this.$t('menu.edit'),
          value: 'edit'
        },
        {
          label: this.$t('menu.edit'),
          value: 'exit'
        }
      ],
      contextMenuShow: false,
      cssStr: '',
      deviceData: null,
      showAttrs: true,
      deviceUpdate: false,
      dialogFormVisible: false,
      deviceTableShow: false,
      currentView: '',
      dialogTitle: '',
      showd: true,
      cont: 'block',
      show2: false,
      showMap: true,
      fullscreen: false,
      showchat: true,
      ModelGroup: {
        deviceGroup: {
          deviceList: false,
          dataMonitor: false,
          dataMonitorTable: false,
          checkedIndex: ''
        }
      },
      properStyle: '',
      time: '',
      day: '',
      socket: null,
      activeName: 'first',
      msgInfo: [],
      alertInfo: [],
      userId: '',
      page: 1,
      linit: 20,
      count: 0,
      newMsg: false,
      perList: [],
      readArr: [],
      userAccount: '',
      window: window,
      tableData: [],
      selectTag: []
    }
  },
  // sockets: {
  //   connect(data) {
  //     console.log('#componnets-mainss connect')
  //   },
  //   disconnect() {
  //     console.log('#componnets-mainss disconnect')
  //     this.$socket.emit('reconnect')
  //   },
  //   reconnect() {
  //     console.log('#componnets-mainss reconnect')
  //     this.$socket.emit('connect')
  //   },
  //   inin(data) {
  //     console.log(data)
  //     if (data.message) {
  //       let temp = data.message
  //       switch (data.actionType) {
  //         case 'updateNotify':
  //           this.clickMsg(data)
  //           break
  //       }
  //     }
  //   },
  //   emit(data) {}
  // },
  created() {
    this.userId = JSON.parse(localStorage.user).userid
    this.userAccount = JSON.parse(localStorage.user).account
    let that = this
    document.onkeydown = function(e) {
      var key = window.event.keyCode
      if (key == 13) {
        that.search()
      }
    }
    this.createWS()
    this.noticeSocket()
    this.$store.commit('userInfo', {
      name: sessionStorage.userName,
      pwd: sessionStorage.userSign
    })
    this.getAlertList()
    this.getSysNotice()
  },
  computed: {
    ...mapState(['modelClickPos', 'attrData']),
    ifDialog() {
      if (JSON.stringify(this.propsDiaData) != '{}') {
        return true
      }
      return false
    },
    meterValue() {
      return this.$store.state.meterStatus
    },
  },
  mounted() {
    setInterval(this.timeWeekFormat, 1000)
    let _this = this
    setTimeout(function() {
      _this.globalClick(_this.getcallback, _this)
    }, 10)
  },
  methods: {
    showAllTag() {
      this.hideAllTag();
      this.tableData.forEach((i, index) => {
        this.selectPos(i, index);
      })
      clearInterval(this.timer);
      this.setTimer();
    },
    hideAllTag() {
      window.ResetAllElement();
      window.markerArray.forEach(ele => {
        window.RemoveMarker(ele);
      });
      window.markerArray = []
      this.selectTag = []
      clearInterval(this.timer)
    },
    getdevicelist() {
      ApiService.tree
        .devicelist({
          mileageID: window.R_config.modelId,
          page: 1,
          linit: 50,
          Type: 2
        })
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data
          }
        })
    },
    selectPos(row, index) {
      ApiService.doc
        .getModelData({
          glid: "",
          bitNumber: row.deviceName,
          mileageID: window.R_config.modelId
        })
        .then(res => {
          window.elementType = 0;
          window.clickGlids = res.data.glid[0];
          window.currentElement = res.data.glid[0];
          // console.log(res.data.glid[0])
          this.addLabel(row, res.data.glid[0], index);
        });
    },
    getStatus(row) {
      if (
        parseFloat(row.qValue) < parseFloat(row.offlineValues) ||
        parseFloat(row.qValue) > parseFloat(row.onlineValue)
      ) {
        return true;
      } else {
        return false;
      }
    },
    addLabel(row, glids, index) {
      // console.log(index)
      window.SetElementColor(glids, 255, 0, 0)
      let htmlStr = `<div id="tips_show" style="top: ${index%2 == 0 ? '' : '-188px'}" class='tips_show' onclick="onLabelClick('${row.deviceName.trim()}')">
                    <div class="tip-icon" style="background:${this.getStatus(row) ? '#F07150' : '#4ACA8A'}">
                      <i class="iconfont ${row.unit === 'kpa' ? 'iconicon_pressure' : 'iconicon_temperature'}"></i>
                    </div>
                    <div class="tip-cont">
                      <p id='deviceName_${row.id}'>${row.deviceName}</p>
                      <p class="p-value" id='qValue_${row.id}'>${row.qValue}${row.unit || ""}</p>
                    </div>
                    <span class="line" style="background:${this.getStatus(row) ? '#F07150' : '#4ACA8A'};height:${index%2 == 0 ? '' : '164px'}"></span>
                    </div>`
      window.currentPos = window.GetCenterById(glids);
      window.clickGlids = glids;
      window.AddHtmlMarker(
        window.currentPos,
        htmlStr,
        "marker" + window.markerArray.length
      );
      window.markerArray.push("marker" + window.markerArray.length);
      this.selectTag.push(row.id);
    },
    setTimer() {
      this.timer = setInterval(() => {
        this.getdevicelist();
        this.showDetail();
      }, 1000);
    },
    showDetail() {
      this.tableData.map(res => {
        if (this.$store.state.eqData && res.id == this.$store.state.eqData.id) {
          this.$store.state.eqData = res;
        }
        this.selectTag.map(item => {
          if (item == res.id) {
            var _obj = document.getElementById("qValue_" + res.id);
            if (_obj) {
              document.getElementById("qValue_" + res.id).innerText =
                res.qValue + (res.unit || "");
            }
          }
        });
      });
    },
    noticeSocket() {
      let _this = this
      const ws = new WebSocket(`${window.R_config.warnSocket}`)
      ws.onopen = function() {
        // console.log('连接公告')
        // ws.send(`NoticeID=${res.ID}`)
      },
      ws.onmessage = function(data) {
        // console.log(data)
        _this.getSysNotice()
        // console.log(_this.newMsg)
      }
    },
    handleDiaClose() {
      this.propsDiaData = {}
    },
    viewSel() {
      this.$store.commit('showModal', {
        name: 'viewCollect',
        show: true,
        top: '1rem',
        left: '10rem'
      })
    },
    clickMenu(data, index) {
      this.currentMenuIndex = index
      if (data.value === 'exit') {
        this.exitMarker()
      }
    },
    resetModel() {
      window.SetView(window.R_config.initView)
    },
    collectFN() {
      vm.$store.commit('showModal', {
        name: 'collect',
        show: true,
        right: '',
        data: null
      })
    },
    createWS() {
      var _this = this
      this.socket = new window.WebSocket(window.R_config.warnSocket)
      this.socket.onclose = function() {
        // console.log('connect close')
        setTimeout(function() {
          _this.reconect()
        }, 2000)
      }
      this.socket.onopen = function() {
        // console.log('连接 盼')
        _this.socket.send(`UserId=${JSON.parse(localStorage.user).userId}`)
      }
      this.socket.onmessage = function(msg) {
        // console.log(msg)
        _this.getAlertList()
      }
    },
    reconect() {
      this.createWS()
    },
    // 获得警告列表
    getAlertList() {
      ApiService.user
        .getAlertList({
          userId: JSON.parse(localStorage.user).userId,
          page: this.page,
          linit: this.linit,
          IsRead: 1
        })
        .then(res => {
          if (res.code === 0) {
            this.count = res.count
            this.alertInfo = res.data
            // if (this.count === 0 && this.msgInfo === 0) {
            //   this.newMsg = false
            // }
          }
        })
    },
    getSysNotice() {
      ApiService.user.getSysMessage({
        userId: JSON.parse(localStorage.user).userId,
        page: this.page,
        linit: this.linit,
        IsRead: 1 // 1=所有  2=未读 3=已读
      }).then(res => {
        if (this.msgInfo.length > 0) {
          this.newMsg = true
        }
        this.msgInfo = res.data
      })
    },
    
    handleSizeChange(val) {
      this.linit = val
      this.getAlertList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getAlertList()
    },
    // 点击警告事件
    setGuid(i) {
      let arr1 = JSON.parse(i.json)
      arr1.push(JSON.parse(localStorage.user).userId)
      let arr = []
      arr.push({
        id: i.id,
        json: JSON.stringify(arr1)
      })
      this.viewWarn()
      this.updateConcernsMsg(arr)
    },
    // 更改消息查看状态
    updateConcernsMsg(val) {
      ApiService.user
        .updateConcernsMsg({
          arrParam: val
        })
        .then(res => {
          this.getAlertList()
        })
    },
    readAll() {
      let arr = []
      this.alertInfo.forEach(element => {
        let arr1 = JSON.parse(element.json)
        arr1.push(JSON.parse(localStorage.user).userId)
        arr.push({
          id: element.id,
          json: JSON.stringify(arr1)
        })
      })
      this.updateConcernsMsg(arr)
    },
    viewNotice(i) {
      this.updateNotice(i)
      this.newMsg = false
      this.$store.commit('showModal', {
        name: 'noticeView',
        show: true,
        top: '2.5rem',
        data: i || null
      })
    },
    viewWarn() {
      this.newMsg = false
      this.$store.commit('showModal', {
        name: 'warnMs',
        show: true,
        top: '2.5rem',
        data: null
      })
    },
    updateNotice(val) {
      let arr = []
      if (val) {
        let arr1 = JSON.parse(val.json)
        arr1.push(JSON.parse(localStorage.user).userId)
        arr.push({
          id: val.id,
          json: JSON.stringify(arr1)
        })
      } else {
        this.msgInfo.map(n => {
          arr.push({
            id: n.id,
            json: JSON.stringify([JSON.parse(localStorage.user).userId])
          })
        })
      }
      ApiService.user.updateNotice({
          arrParam: arr
      }).then(res =>{
        this.getSysNotice()
      })
    },
    groupItemShowChange(groupName, modelname) {
      this.currentView = modelname
      this.show2 = !this.show2
    },
    showViewClick(val) {
      this[val] = !this[val]
      if (!this[val]) {
        window.SetClickMode(0)
      }
    },
    getproperty() {
      ApiService.tree
        .property({
          mileageID: window.R_config.modelId,
          bitNumber: window.Muster
        })
        .then(res => {
          if (res.code == 0) {
            let attrData = res.data
            this.$store.commit('syncAttrData', attrData)
          } else {
            this.$message({
              message: this.$t('menu.cg'),
              type: 'success'
            })
          }
        })
    },
    timeWeekFormat() {
      // 定义一个日期对象
      var dateTime = new Date(Date.now())
      // 获得系统年份
      var year = dateTime.getFullYear()
      // 获得系统月份
      var month = dateTime.getMonth() + 1
      // 获得系统当月分天数
      var day = dateTime.getDate()
      // 获得系统小时;
      var hours = dateTime.getHours()
      // 获得系统分钟;
      var minutes = dateTime.getMinutes()
      // 获得系统秒数;
      var second = dateTime.getSeconds()
      // 获得系统星期几;
      var dayCycle = dateTime.getDay()
      // 使用数组更改日期样式;
      var dayCycleArray = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      const endayCycleArray =  ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      const japCycleArray = ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
      if (this.$utils.getCookie('lang') === 'en'){
        dayCycleArray = endayCycleArray
      } else if (this.$utils.getCookie('lang') === 'jap'){
        dayCycleArray = japCycleArray
      }
      for (var i = 0; i < 7; i++) {
        if (dayCycle == i) {
          // 将dayCycleArray的数赋值到系统星期几里面中去;
          dayCycle = dayCycleArray[i]
        }
      }
      month < 10 ? (month = '0' + month) : month
      day < 10 ? (day = '0' + day) : day
      hours < 10 ? (hours = '0' + hours) : hours
      minutes < 10 ? (minutes = '0' + minutes) : minutes
      second < 10 ? (second = '0' + second) : second
      // 打印完整的系统日期;
      let dateStr =
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        dayCycle +
        ' ' +
        hours +
        ':' +
        minutes +
        ':' +
        second
      this.time = hours + ':' + minutes
      this.day = year + '-' + month + '-' + day + ' ' + dayCycle
      // return dateStr;
    },
    showEQModel(modelobj) {
      this.groupItemShowChange(modelobj.Group, modelobj.modelname)
    },
    sendEQPos() {
      if (window.PData.data.DevicePosition) {
        ApiService.tree.update(window.PData.data).then(res => {
          // console.log(res.data)
        })
      }
    },
    getcallback(data) {
      // console.log('data')
      this.showContextMenu(false)
      // window.OnClickBlank();
      // console.log(data)
      if (data.type == 'getproperty') {
        console.log('data')
        // this.getBitByGlid(data.data)
        this.getproperty()
      } else if (data.type == 'showeqModel') {
        this.showEQModel('editeq')
      } else if (data.type == 'showeqModellist') {
        this.showEQModel('editeqlist')
      } else if (data.type == 'selectPos') {
        this.sendEQPos()
      } else if (data.type == 'deviceClick') {
        this.showContextMenu(true, data)
      } else if (data.type == 'msg') {
        this.GlobalMsg(data.msgContent)
      }
    },
    contextMenuClick({ type, val }) {
      // console.log(type, val)
      if (type == 'modal') {
        if (val === 'viewFile') {
          this.$store.commit('showModal', {
            name: 'fileManage',
            show: true,
            top: '2rem',
            left: '',
            data: 1
          })
          return
        } else if (val === 'fileManage') {
          this.$store.commit('showModal', {
            name: 'fileManage',
            show: true,
            top: '2rem',
            left: '',
            data: 2
          })
          return
        } else if (val === 'fixPlan') {
          this.handleTask({num:window.Muster})
          return
        } else if (val === 'testResult') {
          this.handleCheckResult({num:window.Muster})
          return
        } else if (val === 'corrosion') {
          this.handleRustRate({num:window.Muster})
          return
        } else if (val === 'thick') {
          this.showGraph({num:window.Muster})
          return
        }
        this.$store.commit('showModal', {
          name: val,
          show: true,
          top: '2rem',
          left: '',
          data: window.clickGlids
        })
        this.contextMenuShow = false
      } else if (type == 'op') {
        this.contextMenuShow = false
      }
    },
    handleTask(row) {
      this.handlePropDiaData({
        title: '任务',
        comName: 'amisTask',
        data: row,
        visible: true,
        isFooter: false,
        width: '620px'
      })
    },
    handleCheckResult(row) {
      this.handlePropDiaData({
        title: '检查结果',
        comName: 'amisCheckResult',
        data: row,
        visible: true,
        isFooter: false,
        width: '620px'
      })
    },
    handleRustRate(row) {
      this.handlePropDiaData({
        title: '腐蚀率',
        comName: 'amisRustRate',
        data: row,
        visible: true,
        isFooter: false,
        width: '620px'
      })
    },
    showGraph(row) {
      this.handleDiaData({
        title: '壁厚结果测量',
        comName: 'thickGraph',
        data: row,
        dialogVisible: true,
        isFooter: false,
        width: '620px'
      })
    },
    handlePropDiaData(data) {
      // console.log(data)
      this.$set(this.propsDiaData, 'title', data.title)
      this.$set(this.propsDiaData, 'comName', data.comName)
      this.$set(this.propsDiaData, 'data', data.data)
      this.$set(this.propsDiaData, 'dialogVisible', data.visible)
      this.$set(this.propsDiaData, 'isFooter', data.isFooter)
      this.$set(this.propsDiaData, 'width', data.width)
    },
    handleDiaData(data) {
      this.$set(this.propsDiaData, 'title', data.title)
      this.$set(this.propsDiaData, 'comName', data.comName)
      this.$set(this.propsDiaData, 'data', data.data)
      // this.$set(this.propsDiaData, 'parentCurrentRow', data.parentComData)
      this.$set(this.propsDiaData, 'dialogVisible', data.dialogVisible)
      this.$set(this.propsDiaData, 'isFooter', data.isFooter)
      this.$set(this.propsDiaData, 'width', data.width)
    },
    showContextMenu(show, data) {
      this.contextMenuShow = show
      if (data) {
        this.lisen.$emit('change', data.val)
        this.deviceData = data.val
        this.cssStr = data.cssStr
      }
    },
    GlobalMsg(val) {
      this.$message({
        type: val.status,
        message: val.msg
      })
    },
    openDialog(command) {
      this.currentView = command
      this.dialogFormVisible = !this.dialogFormVisible
      this.show2 = !this.show2
      this.properStyle = ''
    },
    clearDialogStyle() {
      this.properStyle = ''
    },
    handleFullScreen() {
      let element = document.documentElement
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen()
        }
      }
      this.fullscreen = !this.fullscreen
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    },
  }
}
</script>

<style lang="scss">
@import url('../../assets/compcss/mainss.css');
.logo {
  display: flex;
  align-items: center;
  width: 45px;
  margin-right: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
.marker {
  margin: 0 auto;
  display: inline-flex;
  box-shadow: 0px 0px 4px -2px;
  position: fixed;
  top: 50px;
  left: 50vw;
  background-color: white;
  justify-content: space-evenly;
  height: 40px;
  align-items: center;
  cursor: pointer;
  .menu-active {
    color: #0078d7 !important;
    background-color: #e0edf8 !important;
  }
  .marker-menu {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    transition: all 0.3s;
    &:hover {
      color: #0078d7;
    }
  }
}
.reset-view {
  margin-right: 0.2rem;
  cursor: pointer;
  .toggle-meter {
    font-size: 12px;
    border: 1px solid #fff;
    border-radius: 8px;
    height: 20px;
    line-height: 20px;
    padding: 0 8px;
  }
}
.no-data {
  text-align: center;
  margin: 50px;
  color: rgba(255, 255, 255, 0.85);
}
.el-pagination {
  display: flex;
  justify-content: space-between;
}
.alert-list {
  li {
    border-bottom: 1px solid rgba(255, 255, 255, .1);
    padding: 10px;
    cursor: pointer;
    &:hover {
      background: rgba(255, 255, 255, .1);
    }
    .info-top {
      display: flex;
      justify-content: space-between;
      .info-time {
        color: rgba(255, 255, 255, 0.65);
        font-size: 12px;
      }
      .info-name {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.85);
        display: flex;
        align-items: center;
        i {
          margin-right: 5px;
          color: red;
        }
        span {
          width: 190px;
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
    .info-bottom {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span, p {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.65);
        line-height: 24px;
        height: 24px;
        overflow: hidden;
        width: 290px;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      i {
        display: block;
        width: 15px;
        height: 15px;
        margin-right: 6px;
      }
      .b {
        width: 8px;
        height: 8px;
        display: block;
        border-radius: 50%;
        background: red;
        margin-right: 6px;
      }
    }
  }
}
.message-box {
  padding: 0;
  border: 0;
  top: 28px !important;
  height: calc(100vh - 40px);
  background: #1D2C48;
  border-radius: 0;
  // width: 360px;
  .el-tabs__nav {
    width: 100%;
    .el-tabs__item {
      width: 50%;
      text-align: center;
      border: 0;
    }
  }
  .el-tabs--border-card {
    background: transparent;
    border: 0;
  }
  .el-tabs--border-card > .el-tabs__header {
    background: transparent;
    border-color: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.65);
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    background: transparent;
    color: rgba(255, 255, 255, 1);
  }
  .el-tabs__content {
    height: calc(100vh - 80px);
    width: 340px;
    overflow: auto;
    padding: 0;
    padding-bottom: 36px;
  }
  .box-bottom,
  .box-bottom1 {
    height: 36px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    padding: 0 10px;
    color: #fff;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    span {
      cursor: pointer;
      &:hover {
        color: #0078d7;
      }
    }
  }
  .box-bottom {
    background: #1D2C48;
    justify-content: space-between;
  }
  .box-bottom1 {
    background: #1D2C48;
    justify-content: center;
    padding: 0;
  }
  .popper__arrow {
    left: 23%;
  }
}
.deviceTag {
  width: 100px;
  height: 100px;
  border: 1px solid black;
}

.deviceTag i {
  border-left: 0.06rem solid black;
  right: 0.1rem;
  margin-right: -0.1rem;
  margin-bottom: 0.1rem;
  position: relative;
}

.el-tree-node .el-tree-node__content:hover {
  background-color: rgba(2, 65, 154, 0.39);
}

.el-tree-node:focus > .el-tree-node__content {
  background-color: rgba(2, 65, 154, 0);
}

// .el-tree-node__content {
//   color: #ffffff;
// }

.el-checkbox__inner {
  background: rgba(2, 65, 154, 0);
}

.tips {
  background: #fff;
  border-radius: 4px;
  position: relative;
  filter: drop-shadow(1px 1px 7px #333);
  padding: 4px 10px;
  box-sizing: border-box;
  pointer-events: initial;
  right: 55px;

  p:first-child {
    font-size: 16px;
    color: rgba(0, 53, 128, 0.8);
  }

  p:last-child {
    font-size: 24px;
    color: #003580;
  }
}

.tips:before {
  content: '';
  display: block;
  position: absolute;
  bottom: -9px;
  left: 45px;
  width: 0px;
  height: 0px;
  border-right: 10px solid transparent;
  border-left: 10px solid transparent;
  border-top: 10px solid #fff;
}
.cctv-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  p {
    margin-top: 10px;
    color: #104F9E;
    font-size: 14px;
  }
}
.video-img {
  width: 50px;
  height: 70px;
  background: url('../../assets/huayi_img/video_unsel.png') no-repeat center;
  background-size: contain;
}
.video-img-sel {
  width: 50px;
  height: 70px;
  background: url('../../assets/huayi_img/video_sel.png') no-repeat center;
  background-size: contain;
}
.tips_show {
  border-radius: 4px;
  position: absolute;
  background: rgba(34, 52, 85, 0.6);
  top: -122px;
  right: -77px;
  bottom: 0px;
  box-sizing: border-box;
  pointer-events: initial;
  font-size: 0.12rem;
  color: #fff;
  text-align: left;
  width: 122px;
  height: 44px;
  font-family: Microsoft YaHei Regular;
  cursor: pointer;
  .tip-icon {
    width: 44px;
    height: 44px;
    line-height: 44px;
    text-align: center;
    float: left;
    border-radius: 4px 0 0 4px;
    .iconfont {
      font-size: 32px;
    }
  }
  .tip-cont {
    margin-left: 44px;
    width: 78px;
    height: 44px;
    box-sizing: border-box;
    padding: 5px;
    p {
      margin: 0;
      font-size: 12px;
      color: #fff;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .line {
    position: absolute;
    height: 76px;
    width: 3px;
    left: 45px;
    top: 45px;
  }

}

.meter-group {
  // left: 420px;
  // top: 0;
  width: 550px;
  background: rgba(3, 5, 28, 0.78);
  padding: 18px;
  box-sizing: border-box;
  position: absolute;
  top: -84px;
  left: 125px;
  // transform: scale(0);
  opacity: 0;
  transform-origin: -84px 125px;
  img {
    position: absolute;
    left: -150px;
    top: 25px;
  }
  i {
    width: 30px;
    height: 30px;
    border: 2px solid rgba(77, 150, 252, 1);
    display: block;
    position: absolute;
    &:nth-child(1) {
      top: 0;
      left: 0;
      border: {
        right: 0;
        bottom: 0;
      }
    }
    &:nth-child(2) {
      top: 0;
      right: 0;
      border: {
        left: 0;
        bottom: 0;
      }
    }
    &:nth-child(3) {
      bottom: 0;
      left: 0;
      border: {
        right: 0;
        top: 0;
      }
    }
    &:nth-child(4) {
      right: 0;
      bottom: 0;
      border: {
        left: 0;
        top: 0;
      }
    }
  }
  .group-title {
    display: flex;
    border-left: 3px solid rgba(0, 255, 255, 1);
    color: #fff;
    padding-left: 10px;
    margin-bottom: 20px;
    span {
      font-size: 14px;
      padding-right: 10px;
      color: #999;
    }
    p {
      font-size: 14px;
    }
  }
  .group-list {
    display: flex;
    flex-wrap: wrap;
    height: 210px;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 2px;
      height: 210px;
      /**/
    }
    &::-webkit-scrollbar-track {
      background: rgba(23, 78, 176, 0.3);
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: #fff;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #333;
    }
    .group-cont {
      width: 160px;
      background: rgba(23, 78, 176, 0.3);
      text-align: center;
      padding: 10px 0;
      margin-right: 12px;
      margin-bottom: 12px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      span {
        font-size: 18px;
        color: rgba(0, 255, 255, 1);
        margin-bottom: 5px;
      }
      p {
        color: rgba(190, 228, 248, 1);
        font-size: 12px;
      }
    }
  }
}
.dcs-group {
  // left: 420px;
  // top: 0;
  // width: 150px;
  background: rgba(3, 5, 28, 0.78);
  padding: 15px;
  box-sizing: border-box;
  position: absolute;
  top: -84px;
  left: 125px;
  // transform: scale(0);
  opacity: 0;
  transform-origin: -84px 125px;
  img {
    position: absolute;
    left: -150px;
    top: 25px;
  }
  i {
    width: 30px;
    height: 30px;
    border: 2px solid rgba(77, 150, 252, 1);
    display: block;
    position: absolute;
    &:nth-child(1) {
      top: 0;
      left: 0;
      border: {
        right: 0;
        bottom: 0;
      }
    }
    &:nth-child(2) {
      top: 0;
      right: 0;
      border: {
        left: 0;
        bottom: 0;
      }
    }
    &:nth-child(3) {
      bottom: 0;
      left: 0;
      border: {
        right: 0;
        top: 0;
      }
    }
    &:nth-child(4) {
      right: 0;
      bottom: 0;
      border: {
        left: 0;
        top: 0;
      }
    }
  }
  .group-title {
    display: flex;
    border-left: 3px solid rgba(0, 255, 255, 1);
    color: #fff;
    padding-left: 10px;
    margin-bottom: 20px;
    span {
      font-size: 20px;
      padding-right: 10px;
      color: #fff;
    }
    p {
      font-size: 14px;
    }
  }
  .group-list {
    display: flex;
    flex-wrap: wrap;
    &::-webkit-scrollbar {
      width: 2px;
      height: 210px;
      /**/
    }
    &::-webkit-scrollbar-track {
      background: rgba(23, 78, 176, 0.3);
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
      background: #fff;
      border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #333;
    }
    .group-cont {
      width: 230px;
      background: rgba(23, 78, 176, 0.3);
      text-align: center;
      padding: 25px 20px;
      &:nth-child(3n) {
        margin-right: 0;
      }
      >span {
        font-size: 20px;
        color: rgba(0, 255, 255, 1);
        margin-bottom: 5px;
      }
      p {
        color: rgba(190, 228, 248, 1);
        font-size: 40px;
      }
    }
  }
}
.bi-flag {
  width: 314px;
  height: 200px;
  position: fixed;
  top: 60px;
  left: 70px;
  background-size: cover;
  cursor: pointer;
  border-radius: 5px;
  box-sizing: border-box;
  border: 1px solid #409eff;
  video {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/mainss.vue